import React, { Component } from 'react';
import { BrowserRouter as Router, Route} from "react-router-dom";
import Header from './components/Header'
import Top from './components/Top'
import Puzzle from './components/Puzzle'
import Flipcards from './components/Flipcards';
import Todo from './components/Todo';
import Recipe from './components/Recipe';
import Gif from './components/Gif';
import Portfolio from './components/Portfolio';

class App extends Component {
  render() {
    return (
    <Router >
      <div>
        <Header />
        <Route exact path='/'  component={Top}/>
        <Route path='/puzzle' component={Puzzle}/>
        <Route path='/flipcards' component={Flipcards}/>
        <Route path='/todo' component={Todo}/>
        <Route path='/recipe' component={Recipe}/>
        <Route path='/gif' component={Gif}/>
        <Route path='/portfolio' component={Portfolio}/>
      </div>
    </Router >
    );
  }
}

  export default App;


// WEBPACK FOOTER //
// ./src/App.js